module.exports = __webpack_public_path__ + "media/images/flags/3a-f89d803909125b48a28feaa109079eaf.svg";